/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePartRequestDto
 */
export interface UpdatePartRequestDto {
    /**
     * Unique stable code for the part
     * @type {string}
     * @memberof UpdatePartRequestDto
     */
    code?: string;
    /**
     * Display label
     * @type {string}
     * @memberof UpdatePartRequestDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePartRequestDto
     */
    manufacturer?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePartRequestDto
     */
    serialNumber?: string | null;
    /**
     * Flexible bag for type-specific attributes (rating, size, SKU, …)
     * @type {{ [key: string]: any; }}
     * @memberof UpdatePartRequestDto
     */
    properties?: { [key: string]: any; } | null;
}

/**
 * Check if a given object implements the UpdatePartRequestDto interface.
 */
export function instanceOfUpdatePartRequestDto(value: object): value is UpdatePartRequestDto {
    return true;
}

export function UpdatePartRequestDtoFromJSON(json: any): UpdatePartRequestDto {
    return UpdatePartRequestDtoFromJSONTyped(json, false);
}

export function UpdatePartRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePartRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
        'manufacturer': json['manufacturer'] == null ? undefined : json['manufacturer'],
        'serialNumber': json['serialNumber'] == null ? undefined : json['serialNumber'],
        'properties': json['properties'] == null ? undefined : json['properties'],
    };
}

export function UpdatePartRequestDtoToJSON(json: any): UpdatePartRequestDto {
    return UpdatePartRequestDtoToJSONTyped(json, false);
}

export function UpdatePartRequestDtoToJSONTyped(value?: UpdatePartRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
        'manufacturer': value['manufacturer'],
        'serialNumber': value['serialNumber'],
        'properties': value['properties'],
    };
}

